import { Component } from "@angular/core";

@Component({
    selector: "storybook",
    templateUrl: "./storybook.component.html",
})
export class StorybookComponent {
    // Arrays para gerar todas as combinações, mantendo a mesma matriz da sua UI
    colors = ["accent", "primary", "warn"] as const; // todas as variantes
    kinds = ["raised", "stroked", "flat"] as const; // mat-raised-button, mat-stroked-button, mat-button

    weights = [
        { key: "bold", class: "button-bold" },
        { key: "regular", class: "" },
    ] as const;

    sizes = [
        // large aparece habilitado e desabilitado (para bold e regular)
        { key: "large", class: "large-button", includeDisabled: true },
        // medium e small só habilitados
        { key: "medium", class: "", includeDisabled: false },
        { key: "small", class: "small-button", includeDisabled: false },
    ] as const;
}
